module.exports = __webpack_public_path__ + "img/face14.5fb72289.jpg";